import React, { useEffect, useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import { toast } from "react-toastify";
import {useForm} from "react-hook-form";
import STOREAPI from "../../../apis/adminApi/StoreAPI";
import Field from "../../forms/Field";
import MyButton from "../../assets/MyButton";
import DocumentApi from "../../../apis/adminApi/DocumentAPI";
import BusApi from "../../../apis/adminApi/busAPI";

const AddBusDocument = () => {
    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const [showLoader, setShowLoader] = useState(false);
    const [buses, setBus] = useState([]);
    const [docs, setDocs] = useState([]);

    const [busDocument, setStore] = useState({
        document_id : "", bus_id: "", edition : "", alerted_at : "", expired_at:""
    });

    const [errors, setErrors] = useState({
        document_id : "",  bus_id: "",edition : "", alerted_at : "", expired_at:""
    });

    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setStore({...busDocument, [name] : value})
    };

    const fetchBuses = async () => {
        try{
            const data =  await BusApi.findAll();
            setBus(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des bus !");
        }
    };

    const fetchDocuments = async () => {
        try{
            const data =  await DocumentApi.findDocuments();
            setDocs(data);
            setLoading(false);
        }catch(error){
            toast.error("Erreur lors du chargement des documents !");
        }
    };

    useEffect(() => {
        fetchBuses();
        fetchDocuments();
    },[]);


    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await DocumentApi.createBusDocument(busDocument);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Document de bord ajouté avec succès");
            navigate("/admin/documents/bus_documents");
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;
            const {message} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification du busDocument !");
            }else if (message){
                toast.error(message)
            }
        }
    };

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-6">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter un document à un bus</h5>

                                <label htmlFor="document_id" className="form-label">Document</label>
                                <select
                                    className={"form-control mb-3 " + ( errors.document_id && "is-invalid")}
                                    name="document_id"
                                    id="document_id"
                                    value={busDocument.document_id}
                                    onChange={handleChange}
                                >
                                    <option value="" selected>Choisir...</option>
                                    {docs && docs.map(doc =>
                                        <option
                                            style={{fontWeight:"bold"}}
                                            key={doc.id} value={doc.id}>{doc.doc_name}</option>)
                                    }
                                </select>
                                {errors.document_id && <div className="invalid-feedback mb-4">{errors.document_id}</div>}

                                <Field
                                    name="edition"
                                    type="text"
                                    error={errors.edition}
                                    value={busDocument.edition}
                                    onChange={handleChange}
                                    label="Année d'edition"
                                    placeholder="Ex:2023"
                                />


                                <Field
                                    name="expired_at"
                                    type="date"
                                    error={errors.expired_at}
                                    value={busDocument.expired_at}
                                    onChange={handleChange}
                                    label="Date d'expiration"
                                />

                                {/*<Field*/}
                                {/*    name="alerted_at"*/}
                                {/*    type="date"*/}
                                {/*    error={errors.alerted_at}*/}
                                {/*    value={busDocument.alerted_at}*/}
                                {/*    onChange={handleChange}*/}
                                {/*    label="Date d'alerte"*/}
                                {/*/>*/}

                                <label htmlFor="bus_id" className="form-label">Bus</label>
                                <select
                                    className={"form-control mb-2" + ( errors.bus_id && "is-invalid")}
                                    //className={"form-select-lg mb-1 form-control " + ( errors.bus_id && "is-invalid")}
                                    name="bus_id"
                                    id="bus_id"
                                    value={busDocument.bus_id}
                                    onChange={handleChange}
                                >
                                    <option value="" selected>Choisir...</option>
                                    {buses && buses.map(bus =>
                                        <option
                                            style={{fontWeight:"bold"}}
                                            key={bus.id} value={bus.id}>{bus.bus_numberplate}</option>)
                                    }
                                </select>
                                {errors.bus_id && <div className="invalid-feedback mb-4">{errors.bus_id}</div>}

                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to="/admin/documents/bus_documents" className="btn btn-info mx-2">Revenir aux documents de bord</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddBusDocument;
